'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPages = function MdPages(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 5c1.8 0 3.4 1.6 3.4 3.4v10h-8.4l1.8-6.8-6.8 1.8v-8.4h10z m-3.2 23.4l-1.8-6.8h8.4v10c0 1.8-1.6 3.4-3.4 3.4h-10v-8.4z m-15-6.8l-1.8 6.8 6.8-1.8v8.4h-10c-1.8 0-3.4-1.6-3.4-3.4v-10h8.4z m-8.4-13.2c0-1.8 1.6-3.4 3.4-3.4h10v8.4l-6.8-1.8 1.8 6.8h-8.4v-10z' })
        )
    );
};

exports.default = MdPages;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/pages.js
// module id = 3124
// module chunks = 0